module.exports = __webpack_public_path__ + "img/portadapagos.ceb8dcc4.jpg";